import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { ChevronLeft32, ChevronRight32 } from '@carbon/icons-react';

const Pager = ({ advance, rewind }) => {
  return (
    <div css={styles.nav}>
      <button onClick={rewind} css={styles.button}>
        <span className="bx--assistive-text">{`Go to previous step`}</span>
        <ChevronLeft32 css={styles.icon} />
      </button>
      <button onClick={advance} css={styles.button}>
        <span className="bx--assistive-text">{`Go to next step`}</span>
        <ChevronRight32 css={styles.icon} />
      </button>
    </div>
  );
};

const styles = {
  nav: css`
    display: flex;
    gap: 0.5rem;
  `,
  button: css`
    inline-size: 2rem;
    block-size: 2rem;
    padding: 0;
    color: var(--color-white);
    background-color: var(--color-interactive);

    &:hover {
      background-color: var(--color-hover);
    }
  `,
  icon: css``,
};

Pager.propTypes = {
  advance: PropTypes.func.isRequired,
  rewind: PropTypes.func.isRequired,
};

export default Pager;
